var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCabinets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1875 2.1875H12.8125V5.9375H10.3772H9.75216V6.5625V8.54005V9.16505H9.12715H5.87284H5.24784V8.54005V6.5625V5.9375H4.62284H2.1875V2.1875ZM2.1875 6.5625V12.8125H12.8125V6.5625H10.3772V9.16505V9.79005H9.75216H5.24784H4.62284V9.16505V6.5625H2.1875ZM1.5625 5.9375V2.1875V1.5625H2.1875H12.8125H13.4375V2.1875V5.9375V6.5625V12.8125V13.4375H12.8125H2.1875H1.5625V12.8125V6.5625V5.9375Z",
    fill: "#525355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabinets);
export default __webpack_public_path__ + "static/media/cabinets.b5841cdb37e6d6fb003631a2d387f1e3.svg";
export { ForwardRef as ReactComponent };